"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var theme = _a.theme, padding = _a.padding;
    if (!padding) {
        return '';
    }
    if (Array.isArray(padding) && padding.length >= 1 && padding.length <= 4) {
        return "padding: " + padding.map(function (size) { return theme.sizes.default[size] || 'auto'; }).join(' ') + ";";
    }
    console.error('Please provide an array (max 4 elements) for `padding` style helper.');
    return '';
});
